module.exports = __webpack_public_path__ + "static/media/pub1.2c566079.jpg";